module.exports = __webpack_public_path__ + "img/mono-square.c0349f2f.svg";